import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import User from "./dropdown/user/User";
import Notification from "./dropdown/notification/Notification";
import Toggle from "../sidebar/Toggle";
import { useHistory } from "react-router-dom";
import { Icon } from "../../components/Component";
import menu from "../menu/MenuData";

const Header = ({ fixed, theme, className, sidebarToggle, setVisibility, ...props }) => {
  const [searchText, setSearchText] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const searchRef = useRef(null);
  const history = useHistory();
  
  const headerClass = classNames({
    "nk-header": true,
    "nk-header-fixed": fixed,
    [`is-light`]: theme === "white",
    [`is-${theme}`]: theme !== "white" && theme !== "light",
    [`${className}`]: className,
  });

  // Filter suggestions based on search text
  useEffect(() => {
    if (searchText.trim().length > 0) {
      // Flatten menu items including submenus
      const items = [];
      menu.forEach((item) => {
        if (item.link) {
          items.push({
            text: item.text,
            link: item.link,
            icon: item.icon,
          });
        }
        if (item.subMenu) {
          item.subMenu.forEach((subItem) => {
            items.push({
              text: subItem.text,
              link: subItem.link,
              icon: item.icon,
              parent: item.text,
            });
          });
        }
      });
      
      const filtered = items.filter((item) =>
        item.text.toLowerCase().includes(searchText.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 8)); // Limit to 8 suggestions
      setShowSuggestions(true);
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }
  }, [searchText]);

  // Close suggestions when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSuggestionClick = (link) => {
    setSearchText("");
    setShowSuggestions(false);
    history.push(`${process.env.PUBLIC_URL}${link}`);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && suggestions.length > 0) {
      handleSuggestionClick(suggestions[0].link);
    }
  };

  return (
    <div className={headerClass} style={{ backgroundColor: '#1565C0' }}>
      <div className="container wide-xl">
        <div className="nk-header-wrap">
          <div
            className="nk-header-search"
            style={{
              flex: 1,
              maxWidth: "600px",
              marginLeft: 0,
              marginRight: "auto",
              padding: "0 1rem 0 0",
              position: "relative",
            }}
            ref={searchRef}
          >
            <div className="search-content" style={{ position: 'relative', width: '100%' }}>
              <Icon name="search" style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#8b95a7', zIndex: 1 }} />
              <input
                type="text"
                className="form-control border-transparent form-focus-none"
                placeholder="Rechercher..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                onKeyDown={handleKeyDown}
                onFocus={() => searchText.trim().length > 0 && setShowSuggestions(true)}
                style={{ paddingLeft: '2.5rem', paddingTop: '0.75rem', paddingBottom: '0.75rem', height: '44px', borderRadius: '0.5rem', backgroundColor: '#f5f6fa' }}
              />
            </div>
            {showSuggestions && suggestions.length > 0 && (
              <div
                style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  right: 0,
                  marginTop: '0.5rem',
                  backgroundColor: '#fff',
                  borderRadius: '0.5rem',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                  zIndex: 1000,
                  maxHeight: '400px',
                  overflowY: 'auto',
                  border: '1px solid #e5e9f2'
                }}
              >
                {suggestions.map((suggestion, index) => (
                  <div
                    key={index}
                    onClick={() => handleSuggestionClick(suggestion.link)}
                    style={{
                      padding: '0.75rem 1rem',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      borderBottom: index < suggestions.length - 1 ? '1px solid #f1f3f9' : 'none',
                      transition: 'background-color 0.2s',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#f5f6fa';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = '#fff';
                    }}
                  >
                    {suggestion.icon && (
                      <Icon
                        name={suggestion.icon}
                        style={{ marginRight: '0.75rem', color: '#526484', fontSize: '1.125rem' }}
                      />
                    )}
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 500, color: '#364a63', fontSize: '0.875rem' }}>
                        {suggestion.text}
                      </div>
                      {suggestion.parent && (
                        <div style={{ fontSize: '0.75rem', color: '#8b95a7', marginTop: '0.25rem' }}>
                          {suggestion.parent}
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="nk-header-tools">
            <ul className="nk-quick-nav">
              <li className="notification-dropdown" onClick={() => setVisibility(false)}>
                <Notification />
              </li>
              <li className="user-dropdown" onClick={() => setVisibility(false)}>
                <User />
              </li>
              <li className="d-lg-none">
                <Toggle icon="menu" className="toggle nk-quick-nav-icon me-n1" click={sidebarToggle} />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Header;
